export default {"src":"/_next/static/media/ArrowForwardFilled.7fd8f6ee.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};